/**
 * 予約状態区分クラス
 */
export class ReserveStatus {
    static NoGoing = "10"; // 不参加
    static PayApprovalWait = "20"; // 支払い確認待ち
    static Confirm = "30"; // 確定
    static CancelApprovalWait = "40"; // キャンセル承認待ち
    static CancelWaitReserve = "50"; // キャンセル待ち予約中
    static CancelWaitResrveNotified = "60"; // キャンセル待ち予約中_通知済
    static Invalid = "99"; // 無効

    static ReservationStatusMap: { [key: string]: { statusName: string; color: string; borderColor: string } } = {
        "10": { statusName: "不参加", color: "#FFFFFF", borderColor: '1px solid #B4B8B7' },
        "20": { statusName: "支払い確認待ち", color: "#80B3FF", borderColor: '1px solid #6699CC' },
        "30": { statusName: "確定", color: "#FFB380", borderColor: '1px solid #FF8C00' },
        "40": { statusName: "キャンセル承認待ち", color: "#FFB3B3", borderColor: '1px solid #FF6666' },
        "50": { statusName: "キャンセル待ち予約中", color: "#A3C9A8", borderColor: '1px solid #A3C9A8' },
        "60": { statusName: "キャンセル待ち(参加可能)", color: "#80B3FF", borderColor: '1px solid #6699CC' },
        "99": { statusName: "無効", color: "#D3D3D3", borderColor: '1px solid #A9A9A9' }
    };

    // インスタンス変数
    status: string;

    constructor(status: string) {
        this.status = status;
    }

    /**
     * この予約状態区分コードを返却します.
     *
     * @returns 予約状態区分コード
     */
    getCode(): string {
        return this.status;
    }

    /**
     * この予約状態区分名を返却します.
     *
     * @returns 予約状態区分名
     */
    getName(): string {
        return ReserveStatus.ReservationStatusMap[this.status]?.statusName ?? '不明';
    }

    /**
     * この予約状態区分の色を返却します.
     *
     * @returns 予約状態区分色
     */
    getColor(): string {
        return ReserveStatus.ReservationStatusMap[this.status]?.color ?? 'white';
    }

    /**
     * 予約状態区分を表示する状態かどうかを判定します.
     *
     * @returns 予約状態区分を表示する状態であればtrue、そうでなければfalse
     */
    isDesiplayStatus(): boolean {
        return this.status === "20" || this.status === "30" || this.status === "40" || this.status === "50" || this.status === "60";
    }

    /**
     * この予約状態区分のボーダー色を返却します.
     *
     * @returns 予約状態区分ボーダー色
     */
    getBorderColor(): string {
        return ReserveStatus.ReservationStatusMap[this.status]?.borderColor ?? 'white';
    }

    /**
     * この予約状態区分が、ユーザーが操作不可能な状態かどうかを判定する
     */
    isNotShowButton(): boolean {
        const reservedStatuses = [
            ReserveStatus.CancelApprovalWait,
            ReserveStatus.Invalid
        ];
        return reservedStatuses.includes(this.status);
    }

    /**
     * このオブジェクトが20から60の範囲かを判定するメソッド
     */
    isReserved(): boolean {
        const reservedStatuses = [
            ReserveStatus.PayApprovalWait,
            ReserveStatus.Confirm,
            ReserveStatus.CancelApprovalWait,
            ReserveStatus.CancelWaitReserve,
            ReserveStatus.CancelWaitResrveNotified,
        ];
        return reservedStatuses.includes(this.status);
    }

    /**
     * このオブジェクトが予約申請ボタンを表示する予約状態区分であるかどうかを判定するメソッド
     */
    isReserveButtonDisplay(): boolean {
        const reservedStatuses = [
            ReserveStatus.NoGoing
        ];
        return reservedStatuses.includes(this.status);
    }

    /**
     * このオブジェクトがキャンセルボタンを表示する予約状態区分であるかどうかを判定するメソッド
     */
    isCancelButtonDisplay(): boolean {
        const reservedStatuses = [
            ReserveStatus.PayApprovalWait,
            ReserveStatus.Confirm,
            ReserveStatus.CancelWaitReserve,
            ReserveStatus.CancelWaitResrveNotified
        ];
        return reservedStatuses.includes(this.status);
    }

    /**
     * このオブジェクトがキャンセル承認待ち、または支払い確認待ちであるかどうかを判定するメソッド
     */
    isApprovalWait(): boolean {
        const reservedStatuses = [
            ReserveStatus.PayApprovalWait,
            ReserveStatus.CancelApprovalWait
        ];
        return reservedStatuses.includes(this.status);
    }

    /**
     * このオブジェクトがキャンセル待ち予約中であるかどうかを判定する
     */
    isCancelWaitReserve(): boolean {
        const reservedStatuses = [
            ReserveStatus.CancelWaitReserve
        ];
        return reservedStatuses.includes(this.status);
    }

    /**
     * このオブジェクトがキャンセル待ち予約中_通知済であるかどうかを判定する
     */
    isCancelWaitReserveNotified(): boolean {
        const reservedStatuses = [
            ReserveStatus.CancelWaitResrveNotified
        ];
        return reservedStatuses.includes(this.status);
    }

    /**
     * このオブジェクトが確定であるかどうかを判定する
     */
    isConfirm(): boolean {
        const reservedStatuses = [
            ReserveStatus.Confirm
        ];
        return reservedStatuses.includes(this.status);
    }

    /**
     * このオブジェクトがキャンセル承認待ちであるかどうかを判定する
     */
    isCancelApprovalWait(): boolean {
        const reservedStatuses = [
            ReserveStatus.CancelApprovalWait
        ];
        return reservedStatuses.includes(this.status);
    }

    /**
     * このオブジェクトが支払い確認待ちであるかどうかを判定する
     */
    isPayApprovalWait(): boolean {
        const reservedStatuses = [
            ReserveStatus.PayApprovalWait
        ];
        return reservedStatuses.includes(this.status);
    }
}
